<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header">
  <div class="page-content-wider">
    <h1 class="offers-header-title">{{getHeaderTitle()}}</h1>
    {{getHeaderText()}}
  </div>
</div>

<div class="page-content-wider">

  <div class="store-media-selectors-container">
    <div class="personal-lists-toolbar">
      <div class="list-type-selector-container personal-lists-type-selector">
        <div class="list-selection-text">{{getString('listSelection')}}</div>
        <nav class="list-type-selector" aria-label="Lists">
          <div class="list-type-wrapper" *ngFor="let listType of getListTypes(); let i = index">
            <a class="list-type-item" [routerLink]="getListTypeUrl(listType)" [class.active]="isActiveListType(listType)">
              <span class="material-icons list-type-icon" aria-hidden="true">{{listType.icon}}</span>
              <span class="list-type-label"><span *ngFor="let labelPart of getListTypeLabelParts(listType)">{{labelPart}}</span></span>
            </a>
            <div class="headerDivider" *ngIf="i != getListTypes().length - 1"></div>
          </div>
        </nav>
      </div>
      <div class="store-media-selectors-content">
        <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
        <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
        [nolinks]="true" (onMediaChanged)="mediaChanged($event)">
        </app-media-selector>
      </div>
    </div>
  </div>

  <div class="filters-container-test">

    <div class="small-horizontal-border"></div>

    <div class="normal-filters">
      <div class="filters-panel" [class.fp-close]="isFiltersPanelOpen == false">

        <div class="filter-test-mobile-sort">
          <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [default]="sortValues[0]" [right]="true" (onItemSelected)="sortChanged('onsale', $event)"></app-dropdown>
        </div>

      </div>
    </div>

    <div class="special-filter">
      <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged('onsale', $event)"></app-dropdown>
    </div>
  </div>

  <div *ngIf="!techError" class="items-container">

    <div class="item-container" *ngFor="let item of items; let i = index;">
      <app-date-separator [mode]="'day'" [shouldDisplay]="showDateSeparator(item, i)"
      [date]="getDate(item)"></app-date-separator>
      <app-grid-item-blocklist [item]="item" [priceHint]="'offerslist'" [store]="getStore()"
      (onRemoveFromBlocklistClicked)="removeFromBlocklist(item)"
      ></app-grid-item-blocklist>
    </div>

  </div>

  <div class="not-supported" *ngIf="!mediaSupportedForCountry()">{{getString('mediaNotSuportedForCountry')}}</div>

  <div class="results-end" *ngIf="resultsEndReached && (!items || items.length == 0)">{{getString('emptyBlocklist')}}</div>
  <div class="results-end" *ngIf="resultsEndReached && items && items.length > 0">{{getString('endOfResults')}}</div>
  <div class="results-end" *ngIf="techError">{{getString('technicalProblems')}}
    <div><button type="button" (click)="reload()">{{getString('reload')}}</button></div>
  </div>

</div>

<div *ngIf="showSpinner" class="spinner-container txt-algn-cntr">
  <app-spinner></app-spinner>
</div>

<app-scroll-top *ngIf="showScrollToTopButton"></app-scroll-top>

<app-authentication #authentication></app-authentication>
